/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordCustomerFieldComponent } from '../../admin/form/form-record/fields/customer/form-record-customer-field.component';
/* eslint-enable */

export class FormRecordCustomerFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordCustomerFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
